import { useState } from "react";
import { useTranslation } from "react-i18next";
import showDialog from "../../../utils/ShowDialog/ShowDialog";
import * as ReworkProductService from "../../../../services/reworkProductServices";
import { STANDALONE_EXPEDITION } from "../../../../constants";
import PATHS from "../../../../constants/paths";
import { useNavigate } from "react-router-dom";

export const useReworkProduct = (processType, onSuccess) => {
  const { t } = useTranslation();
  const [data, setData] = useState(null);
  const navigate = useNavigate();

  const handlerDelete = async (uuid, totalIn, totalOut) => {
    try {
      const okAction = async () => {
        try {
          if (totalIn > 0) {
            showDialog(
              t("forms.reworkProduct.messages.delete.titleError"),
              t("forms.reworkProduct.messages.delete.errorIn"),
              "error",
              false,
              "Ok",
            );
            return false;
          }
          if (totalOut > 0) {
            showDialog(
              t("forms.reworkProduct.dialog.delete.titleError"),
              t("forms.reworkProduct.dialog.delete.errorOut"),
              "error",
              false,
              "Ok",
            );
            return false;
          }
          const result = await ReworkProductService.deleteReworkProduct(uuid);
          if (result) {
            setData(null);
            showDialog(
              t("forms.reworkProduct.dialog.delete.titleSuccess"),
              t("forms.reworkProduct.dialog.delete.textSuccess"),
              "success",
              false,
              "Ok",
            );
            navigate(PATHS.REWORK_PRODUCT_LIST);
          }
        } catch (error) {
          showDialog(
            t("forms.reworkProduct.dialog.delete.errorTitle"),
            t("forms.reworkProduct.dialog.delete.errorText"),
            "error",
            false,
            "Ok",
          );
        }
      };

      const cancelAction = () => {};

      showDialog(
        t("forms.reworkProduct.dialog.delete.title"),
        t("forms.reworkProduct.dialog.delete.text"),
        "question",
        true,
        t("forms.reworkProduct.dialog.delete.buttonOk"),
        false,
        okAction,
        t("forms.reworkProduct.dialog.delete.buttonNo"),
        cancelAction,
      );
    } catch (error) {
      console.error("Error en handlerDelete:", error);
    }
  };

  const executeRemove = async (bb) => {
    try {
      let result;

      result = await ReworkProductService.removeItem(bb.uuid, processType);

      if (result) {
        setData(result);

        let okAction = () => {
          onSuccess();
        };

        showDialog(
          t("forms.reworkProduct.messages.remove.title"),
          t("forms.reworkProduct.messages.remove.text"),
          "success",
          false,
          "Ok",
          false,
          okAction(),
        );
      }
    } catch (error) {}
  };

  const handlerRemove = async (bb) => {
    try {
      const okAction = () => {
        executeRemove(bb);
      };

      const cancelAction = () => {};

      showDialog(
        t("forms.reworkProduct.dialog.remove.title"),
        t("forms.reworkProduct.dialog.remove.text"),
        "warning",
        true,
        t("forms.reworkProduct.dialog.remove.buttonOk"),
        false,
        okAction,
        t("forms.reworkProduct.dialog.remove.buttonNo"),
        cancelAction,
      );
    } catch (error) {}
  };

  const executeFinish = async (uuid) => {
    try {
      let result;
      result = await ReworkProductService.finishReworkProduct(uuid);

      if (result && result === "OK") {
        setData(null);

        let okAction = () => {
          onSuccess();
        };

        showDialog(
          t("forms.reworkProduct.messages.finish.title"),
          t("forms.reworkProduct.messages.finish.text"),
          "success",
          false,
          "Ok",
          okAction(),
        );
      }
    } catch (error) {}
  };

  const handlerFinish = async (totalIn, totalOut, uuid) => {
    try {
      if (totalOut <= 0) {
        showDialog(
          t("forms.reworkProduct.messages.finish.title"),
          t("forms.reworkProduct.messages.finish.errorOut"),
          "error",
          false,
          "Ok",
        );
        return false;
      }
      if (totalIn <= 0) {
        showDialog(
          t("forms.reworkProduct.messages.finish.title"),
          t("forms.reworkProduct.messages.finish.errorIn"),
          "error",
          false,
          "Ok",
        );
        return false;
      }

      const okAction = () => {
        executeFinish(uuid);
      };

      const cancelAction = () => {};
      showDialog(
        t("forms.reworkProduct.dialog.finish.title"),
        t("forms.reworkProduct.dialog.finish.text"),
        "question",
        true,
        t("forms.reworkProduct.dialog.finish.buttonOk"),
        false,
        okAction,
        t("forms.reworkProduct.dialog.finish.buttonNo"),
        cancelAction,
      );
    } catch (error) {}
  };

  return {
    data,
    handlerRemove,
    handlerFinish,
    handlerDelete,
  };
};
